import { MyOrderCircle } from '../../icon/swapV3';
import { FormattedMessage } from 'react-intl';
import React, { createContext } from 'react';

export const ORDER_TYPE_KEY = 'REF_FI_ORDER_TYPE_VALUE';

export const MobileInfoBanner = ({
  text,
  value,
}: {
  text: string | JSX.Element;
  value: string | JSX.Element;
}) => {
  return (
    <div className="flex mb-4 items-center justify-between whitespace-nowrap">
      <span className="text-xs text-v3SwapGray">{text}</span>
      <span className="text-white text-sm">{value}</span>
    </div>
  );
};

export function NoOrderCard({ text }: { text: 'active' | 'history' }) {
  return (
    <div className="w-full rounded-xl overflow-hidden h-48 relative text-white font-normal  flex items-center justify-center">
      <div className="flex items-center flex-col relative text-center z-50 mx-auto">
        <span className="mb-4">
          <MyOrderCircle />
        </span>

        <span>
          <FormattedMessage
            id={`your_${text}_orders_will_appear_here`}
            defaultMessage={'Your orders will appear here'}
          />
          .
        </span>
      </div>
    </div>
  );
}

export const PriceContext = createContext(null);

export const REF_FI_MY_ORDER_SHOW_HISTORY_SWAP_INFO =
  'REF_FI_MY_ORDER_SHOW_HISTORY_SWAP_INFO';

export function SwitchTabItem(props: any) {
  const { active, clickEvent } = props;
  return (
    <div
      className="flex items-center text-sm text-primaryText cursor-pointer"
      onClick={clickEvent}
    >
      <span className="flex items-center justify-center rounded-full w-3.5 h-3.5 border border-greenColor border-opacity-50 mr-1">
        <label
          className={`w-2 h-2 rounded-full bg-greenColor ${
            active ? '' : 'hidden'
          }`}
        ></label>
      </span>
      {props.children}
    </div>
  );
}
